import type { MouseEvent } from 'react'
import { FileText } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'

const ICON_CLASS = 'h-4 w-4 shrink-0'

/**
 * Shared statement-document icon for list tables (reimbursements and any future callers).
 * Matches the document metaphor used elsewhere (FileText) with consistent sizing.
 */
export function StatementListDocumentIcon({ className }: { className?: string }) {
  return <FileText aria-hidden className={cn(ICON_CLASS, className)} />
}

export const statementListDownloadIconButtonClassName =
  'mx-auto inline-flex items-center justify-center rounded-md border border-slate-200 p-1.5 text-[rgb(21_151_255)] transition-colors hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-60'

interface StatementListDownloadIconButtonProps {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  /** Accessible name only — Angular default-list has no visible hover panel on the statement icon. */
  'aria-label': string
  dataTestId?: string
}

export function StatementListDownloadIconButton({
  onClick,
  'aria-label': ariaLabel,
  dataTestId,
}: StatementListDownloadIconButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      className={statementListDownloadIconButtonClassName}
    >
      <StatementListDocumentIcon />
    </button>
  )
}

/** Column header: visible “Statement” label only (row actions keep the document icon). */
export function StatementListColumnHeader() {
  return (
    <th
      className="!text-center"
      scope="col"
      data-testid="statement-list-column-header"
    >
      <span className="text-[13px] font-semibold leading-snug text-slate-700">Statement</span>
    </th>
  )
}
